import { render, staticRenderFns } from "./search-destination-filters.vue?vue&type=template&id=630541e6"
import script from "./search-destination-filters.vue?vue&type=script&lang=js"
export * from "./search-destination-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports